module.exports = __webpack_public_path__ + "static/media/button_click.5ab077e3.mp3";